<template lang="pug">
  .member-item
    v-card.py-4(flat)
      v-row(no-gutters align="center")
        v-col.pa-3.shrink
          intel-avatar(:code="member.user.avatar_code" :id="member.user.id" size="60")
        v-col.pr-2
          p.mb-1.p2.textColorHint--text {{ member.role }}
          template(v-if="member.role === 'Cashier'")
            v-layout.my-6(v-if="isFetching" style="padding:25px")
              v-row.fill-height.ma-0(align='center' justify='center')
                v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
            template(v-else)
              p.mb-1.p2.primary500--text(v-if="cashier") {{ $t('username') }}: {{ cashier.username }}
          template(v-else)
            p.mb-1.s1.primary500--text {{ member.user.first_name + ' ' + member.user.last_name }}
            p.mb-1.p2.primary500--text {{ $t('lead') }}: {{ member.total_leads }}
            p.mb-0.p2.primary500--text(v-if="authMember.role === 'Admin' || authMember.id == member.id") {{ $t('sales') }}: {{ member.total_sales | displayPrice }}
        v-col.shrink(align="end" v-if="authMember.role === 'Admin'")
          y-switch.py-0.my-0(v-model="status" :disabled="statusDisable")
          div.d-flex.justify-end.align-end
            v-menu(left top)
              template(v-slot:activator='{ on }')
                v-btn.mt-3.mr-1(text icon min-width="auto" :ripple="false" v-on='on')
                  eva-icon(name="more-vertical" :fill="$vuetify.theme.themes[$theme].primary500" height="25" width="25" )
              v-list(dense)
                v-list-item(@click="clickEdit")
                  v-list-item-content
                    v-list-item-title.s2.basic800--text {{ $t('edit_member') }}
                v-list-item(@click="clickDelete" :disabled="company.primary_owner === member.id")
                  v-list-item-content
                    v-list-item-title.s2(:class="company.primary_owner === member.id ? 'basic500--text' : 'basic800--text'") {{ $t('delete_member') }}

    .modals
      add-new-cashier(v-if="openAddNewCashierDialog" :open.sync="openAddNewCashierDialog" :parentCashier.sync="cashier" :company="company")
      add-member(v-if="openEditAdminDialog" :open.sync="openEditAdminDialog" :parentMember.sync="member" :company="company")
      y-dialog(v-if="openDeleteDialog" v-model='openDeleteDialog', max-width='320')
        v-card
          v-card-title.h6.basic800--text.px-4 {{ $t('delete_member') }}
          v-card-text.p2.primary500--text.px-4
            div {{ $t('delete_member_description', { name: member.user.first_name }) }}
          v-card-actions
            v-spacer
            v-btn(color='white', text @click='openDeleteDialog = false')
              .button-Aa-small.primary400--text {{ $t('cancel') }}
            v-btn.mr-2(color='danger500' depressed height=32 @click='startDelete' :loading="isLoading" dark)
              .button-AA-small.basic100--text {{ $t('delete') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AddNewCashier from '@/components/restaurant/dialogs/AddNewCashier.vue'
import AddMember from '@/components/dialogs/AddMember.vue'
import IntelAvatar from '@/components/IntelAvatar.vue'

export default {
  name: 'UserItem',
  props: ['parentMember', 'disableSwitch'],
  components: { AddNewCashier, AddMember, IntelAvatar },
  data: () => ({
    isLoading: false,
    isFetching: false,
    openDeleteDialog: false,
    openAddNewCashierDialog: false,
    openEditAdminDialog: false,
    cashier: null
  }),
  computed: {
    authMember () {
      return this.$store.state.user.member
    },
    ...mapGetters({
      company: 'getCompany'
    }),
    member: {
      get () {
        return this.parentMember
      },
      set (newValue) {
        this.$emit('update:parentMember', newValue)
      }
    },
    status: {
      get () {
        return this.member.status === 'active'
      },
      set (newValue) {
        this.updateMember(newValue)
        // this.$emit('update:parentMember', newValue)
      }
    },
    statusDisable () {
      if (!this.status && this.disableSwitch) {
        return true
      } else {
        return false
      }
    }
  },
  mounted () {
    if (this.member.role === 'Cashier') {
      this.fetchCashier()
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchCashier () {
      this.isFetching = true
      this.$axios.get(`/pos/${this.company.slug}/staffs`)
        .then(resp => {
          if (resp.data.results.length > 0) {
            let data = resp.data.results.find(f => f.member === this.member.id)
            if (data) {
              this.cashier = data
            }
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    clickEdit () {
      if (this.member.role === 'Cashier') {
        this.openAddNewCashierDialog = true
      } else {
        this.openEditAdminDialog = true
      }
    },
    clickDelete () {
      this.openDeleteDialog = true
    },
    startDelete() {
      this.isLoading = true
      this.axios.delete(`/members/${this.member.id}/`)
        .then(() => {
          this.$emit('deleted', this.member)
          this.showMessage(['success', this.$t('success_message.member_successfully_deleted')])
          this.openDeleteDialog = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    updateMember (val) {
      this.$emit('updateLocal', val)
      let status = ''
      let word = ''
      if (val) {
        status = 'active'
        word = 'activate'
      } else {
        status = 'inactive'
        word = 'inactivate'
      }
      this.$axios.patch(`/members/${this.member.id}/`, { status: status})
        .then(resp => {
          this.$set(this.member,'status', resp.data.status)
          this.$emit('check')
          this.showMessage(['success', `Member ${word} successfull.`])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    }
  }
}
</script>

<style scoped>
.title-name {
  height: 20px;
  overflow: hidden;
}
.border-bottom{
  border-bottom: 1px solid var(--v-basic300);
  border-radius: 0 !important;
}
</style>

<i18n>
{
  "en": {
    "delete_member_description": "Are you sure you want to delete {name}? Say good bye to {name} forever. Existing leads will be delegated to primary owner."
  },
  "id": {
    "delete_member_description": "Anda yakin ingin menghapus {name}? Ucapkan selamat tinggal pada {name} selamanya. Prospek yang ada akan didelegasikan ke pemilik utama."
  }
}
</i18n>